import { forwardRef, type SVGProps } from 'react';

export interface TidyVerticalIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const TidyVerticalIcon = forwardRef<SVGSVGElement, TidyVerticalIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path d="M26.875 6.66699C26.875 5.81555 26.1844 5.125 25.333 5.125H21.125V26.875H25.333C26.1844 26.875 26.875 26.1844 26.875 25.333V6.66699ZM13.125 26.875H18.875V5.125H13.125V26.875ZM5.125 25.333C5.125 26.1844 5.81555 26.875 6.66699 26.875H10.875V5.125H6.66699C5.81555 5.125 5.125 5.81555 5.125 6.66699V25.333ZM29.125 25.333C29.125 27.4271 27.4271 29.125 25.333 29.125H6.66699C4.57291 29.125 2.875 27.4271 2.875 25.333V6.66699C2.875 4.57291 4.57291 2.875 6.66699 2.875H25.333C27.4271 2.875 29.125 4.57291 29.125 6.66699V25.333Z" />
  </svg>
));

TidyVerticalIcon.displayName = 'TidyVerticalIcon';
